/* eslint-disable react/jsx-props-no-spreading */
import { Tabs, withStyles } from "@material-ui/core";

const CustomTabs = withStyles({
  root: {
    border: "1px solid #e8e8e8",
    borderRadius: "5px",
  },
  indicator: {
    display: "none",
  },
})(Tabs);

export default CustomTabs;
